import { Provider } from "@angular/core";
import { CommonContentService } from "./common-content.service";

// def
export {
    Errors,
    Labels,
    Messages,
    OtherValues
} from "./def/common-content";

// services
export * from "./common-content.service";

export const ContentServiceProviders: Provider[] = [CommonContentService];
